module.exports = __webpack_public_path__ + "img/icon-light-left.f2c28c58.png";